import TimePicker from './components/TimePicker';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'timePicker',
  pluginComponent: TimePicker,
});
